import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        updatesAndCommentSection: {
            [theme.breakpoints.down('sm')]: {
                padding: '0 15px 0 15px',
            },
            width: '100%'
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start'
        }
    }),
);

export default useStyles;